<template>
  <!-- Cards 86akqwgcv / 86akqwgkw: filtro por nível (rampa clicável, como no
       backoffice) e busca de aula pelo nome na aba Materiais. -->
  <div class="finder">
    <div
      v-if="levels.length"
      class="ramp"
      role="group"
      :aria-label="$t('course.filterByLevel')"
    >
      <span class="ramp__label">{{ $t("course.level") }}</span>
      <button
        v-for="(item, index) in levels"
        :key="item.key"
        type="button"
        class="ramp__step"
        :class="{ 'ramp__step--on': level === index }"
        :style="{ '--tier': item.color }"
        :aria-pressed="String(level === index)"
        @click="$emit('update:level', level === index ? null : index)"
      >
        <span class="ramp__dot"></span>{{ item.label || item.key }}
      </button>
    </div>

    <div class="sift">
      <label class="sift__search">
        <i class="mdi mdi-magnify sift__search-icon" aria-hidden="true"></i>
        <input
          :value="search"
          type="search"
          class="sift__input"
          :placeholder="placeholder || $t('course.searchPlaceholder')"
          :aria-label="placeholder || $t('course.searchPlaceholder')"
          @input="$emit('update:search', $event.target.value)"
        />
      </label>

      <p v-if="summary" class="sift__state">{{ summary }}</p>

      <button
        v-if="search || level !== null"
        type="button"
        class="sift__clear"
        @click="clear"
      >
        {{ $t("course.clearFilters") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseFinder",
  props: {
    search: { type: String, default: "" },
    // Índice do degrau selecionado em `levels` (null = todos).
    level: { type: Number, default: null },
    // Sem níveis, o componente mostra só a busca.
    levels: { type: Array, default: () => [] },
    summary: { type: String, default: "" },
    placeholder: { type: String, default: "" },
  },
  methods: {
    clear() {
      this.$emit("update:search", "");
      this.$emit("update:level", null);
    },
  },
};
</script>

<style scoped>
.finder {
  margin: 22px 0 32px;
  font-family: "Poppins", sans-serif;
}
.ramp {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  margin-bottom: 16px;
  font-size: 12px;
  color: var(--dk-faint, #9a96a6);
}
.ramp__label {
  margin-right: 4px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}
.ramp__step {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 12px;
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  font: inherit;
  font-weight: 500;
  color: var(--dk-ink-soft, #6e6a79);
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease, color 0.18s ease;
}
.ramp__step:not(.ramp__step--on):hover {
  border-color: var(--dk-line, #e4dfec);
  background: var(--dk-paper, #faf8fc);
}
.ramp__step:focus-visible {
  outline: 3px solid var(--tier);
  outline-offset: 2px;
}
.ramp__step--on {
  border-color: var(--tier);
  background: var(--tier);
  color: #fff;
}
.ramp__dot {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex: none;
  background: var(--tier);
}
.ramp__step--on .ramp__dot {
  background: var(--dk-surface, #fff);
}
.sift {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 18px;
}
.sift__search {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 260px;
  max-width: 380px;
  padding: 9px 16px;
  border: 1px solid var(--dk-line, #e4dfec);
  border-radius: 999px;
  background: var(--dk-paper, #faf8fc);
  transition: border-color 0.18s ease;
}
.sift__search:focus-within {
  border-color: var(--dk-pink, #e8276f);
}
.sift__search-icon {
  font-size: 18px;
  line-height: 1;
  color: var(--dk-faint, #9a96a6);
}
.sift__input {
  flex: 1;
  min-width: 0;
  border: 0;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  color: var(--dk-ink, #211b2e);
}
.sift__input::placeholder {
  color: var(--dk-faint, #9a96a6);
}
.sift__input:focus {
  outline: none;
}
.sift__state {
  margin: 0;
  font-size: 13px;
  color: var(--dk-ink-soft, #6e6a79);
}
.sift__clear {
  margin-left: auto;
  border: 0;
  background: none;
  font-family: inherit;
  font-size: 13px;
  color: var(--dk-faint, #9a96a6);
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}
.sift__clear:hover {
  color: var(--dk-pink, #e8276f);
}
@media (prefers-reduced-motion: reduce) {
  .ramp__step,
  .sift__search {
    transition: none;
  }
}
</style>
